import { Controller } from 'stimulus'

require('summernote/dist/summernote-bs4.js');
require('summernote/dist/summernote-bs4.css');

export default class extends Controller {
  static targets = []

  connect(){

    $('[data-editor="summernote"]').summernote({
      maxHeight: 200,
      fontWeight: 300,
      prettifyHtml: true,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link', 'picture']],
        ['view', ['fullscreen']]
      ]
      });
      }
    }
